import { render } from "./QuestionnaireHeader.vue?vue&type=template&id=6ddf1758"
import script from "./QuestionnaireHeader.vue?vue&type=script&lang=js"
export * from "./QuestionnaireHeader.vue?vue&type=script&lang=js"

import "./QuestionnaireHeader.vue?vue&type=style&index=0&id=6ddf1758&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__